/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './log-retrieval.scss';
import logRetrievalTemplate from './log-retrieval.tpl.html';
/* eslint-disable import/no-unresolved, import/default */
/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.logRetrieval', [])
    .directive('tkGatewayLogRetrieval', GatewayLogRetrieval)
    .name;

/*@ngInject*/
function GatewayLogRetrieval() {
    return {
        restrict: "E",
        require: "^ngModel",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: GatewayLogRetrievalController,
        controllerAs: 'vm',
        templateUrl: logRetrievalTemplate
    };
}

/*@ngInject*/
function GatewayLogRetrievalController($q, $rootScope, $scope, $element, $translate, $filter, $mdMedia, importExport, gatewayService,
    toast, types, utils, gatewayCommandService) {
    var vm = this;
    var gatewaFileStatusSubscriptions = {};
    var xferIds = [];
    vm.isLogRetrievalInProgress = false;
    vm.$onInit = function () {
        vm.types = types;
        vm.logs = [];
        vm.allLogs = [];
        vm.selectedLogs = [];
        vm.configRowsCount = 0;
        vm.limitOptions = [15, 30, 45];
        vm.query = {
            order: 'name',
            limit: 15,
            page: 1
        };

        vm.onLogsReorder = function () {
            updateLogs();
        };

        vm.onLogsPaginate = function () {
            updateLogs();
        };

        vm.retrieveLogs = retrieveLogs;
        vm.downloadSelectedLogs = downloadSelectedLogs;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    $scope.$watch(
        () => $mdMedia('gt-md'),
        (isGtMd) => {
            vm.isGtMd = isGtMd;
            if (vm.isGtMd) {
                vm.limitOptions = [15, 30, 45];
            } else {
                vm.limitOptions = null;
            }
        }
    );

    function reload() {
        vm.logs = [];
        vm.allLogs = [];
        vm.selectedLogs = [];
        vm.configRowsCount = 0;
    }

    function retrieveLogs() {
        reload();
        vm.retrieveLogsPromise = gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.fopsScanDir.value,
            { "path": "/logs" }
        );

        if (vm.retrieveLogsPromise) {
            vm.retrieveLogsPromise.then(
                (data) => {
                    vm.allLogs = data.entries;
                    updateLogs();
                },
                (rejection) => {
                    updateLogs();
                    showError(rejection.data);
                }
            );
        }
    }

    function updateLogs() {
        var result = $filter('orderBy')(vm.allLogs, vm.query.order);
        vm.configRowsCount = result.length;
        const startIndex = vm.query.limit * (vm.query.page - 1);
        vm.logs = result.slice(startIndex, startIndex + vm.query.limit);
    }

    function downloadSelectedLogs() {

        const requiredFiles = vm.selectedLogs.map(log => /logs/ + log.name);

        gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.logRetrieveStart.value,
            { "requiredFiles": requiredFiles })
        .then(
            (response) => {
                if (response.backupDir) {
                    scanBackupDirectory(response.backupDir)
                } else {
                    stopLogRetrieval($q);
                    showError(response.status);
                }
            },
            (rejection) => showError(rejection.data)
        );
    }

    function scanBackupDirectory(path) {
        gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.fopsScanDir.value,
            { "path": `${path}` }
        ).then(
            (files) => proceedFiles(files, path),
            (rejection) => showError(rejection.data)
        )
    }

    async function proceedFiles(files, path, checkFilePromise) {
        for (let file of files.entries) {
            vm.isLogRetrievalInProgress = true;
            await checkFile(file, path);
        }
        stopLogRetrieval(checkFilePromise);
        showSuccessMessage();
    }

    function checkFile(file, path) {
        const token = utils.generateFileToken();
        return $q((resolve, reject) => {
            gatewayService.saveFileTransferToken(token)
                .then(response => {
                    if (response) {
                        subscribeForFileStatus(token, file, { resolve, reject });
                        startFileStream(file, path, token, { resolve, reject });
                    }
                })
                .catch((error) => {
                    stopLogRetrieval({ resolve, reject });
                    showError(error.data);
                });
        });
    }

    function startFileStream(file, path, token, checkFilePromise) {
        const request = {
            path: `/${path}/${file.name}`,
            offset: 0,
            size: file.size,
            token: token
        };
        gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.fopsStreamStart.value,
            request
        )
            .then((data) => {
                if (data && data.status !== types.responseStatus.ok) {
                    stopLogRetrieval(checkFilePromise);
                }
                else {
                    xferIds.push(data.xferId);
                }
            })
            .catch((error) => { 
                stopLogRetrieval(checkFilePromise);
                showError(error.data);
            });
    }

    function stopFileStream(xferId, checkFilePromise) {
        gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.fopsStreamStop.value,
            {xferId: xferId}
        )
            .then((data) => {
                if (data.status !== types.responseStatus.ok) {
                    stopLogRetrieval(checkFilePromise);
                }
            })
            .catch((error) => {
                stopLogRetrieval(checkFilePromise);
                showError(error.data);
            });
    }

    function subscribeForFileStatus(token, file, checkFilePromise) {
        if (token) {
            gatewaFileStatusSubscriptions[token] = gatewayService
                .subscribeForGatewayFilesStatusData(vm.gatewayId.id, (wsFileToken) => {
                    if (wsFileToken && wsFileToken.token === token) {
                        downloadFileFromMqttBridge(wsFileToken, file, checkFilePromise);
                    }
                })
        }
    }

    function downloadFileFromMqttBridge(wsFileToken, file, checkFilePromise) {
        gatewayService.downloadFileFromMqttBridge(wsFileToken.token)
            .then(data => {
                importExport.downloadFile(data, `${file.name}`, types.fileType.LOG);
                unsubscribeFromFileStatus();
                if (xferIds.length) {
                    stopFileStream(xferIds[xferIds.length - 1]);
                }
                checkFilePromise.resolve();
            })
            .catch((error) => {
                showError(error.data);
                stopLogRetrieval(checkFilePromise)
            });
    }

    function unsubscribeFromFileStatus() {
        for (let token in gatewaFileStatusSubscriptions) {
            gatewaFileStatusSubscriptions[token]();
        }
        gatewaFileStatusSubscriptions = {};
    }

    function stopLogRetrieval(checkFilePromise) {
        gatewayCommandService.executeCommand(
            vm.gatewayId.id,
            types.gatewayLogCommand.logRetrieveStop.value,
            {}
        ).then(() => {
            vm.isLogRetrievalInProgress = false;
            if (checkFilePromise) {
                checkFilePromise.reject();
            }
        })
        .catch(error => {
            vm.isLogRetrievalInProgress = false;
            showError(error.data);
        })
    }

    function showError(error, position = 'bottom left') {
        toast.showError(error, $element.closest(".toast-parent"), position)
    }

    function showSuccessMessage(position = 'bottom left') {
        toast.showSuccess($translate.instant('file-transfer.log-retrieval-success'), 750, $element.closest(".toast-parent"), position);
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/log-retrieval/log-retrieval.directive.js